import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, OnDestroy, HostListener } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { AppConfigService } from './services/app.config.service';
import { OpenPoService } from './services/open-po.service';
import { CommonService } from './common.service';
// export interface UserAzure {
//   businessPhones: [];
//   displayName: string;
//   givenName: string;
//   id: string;
//   jobTitle: string;
//   mail: String;
//   mobilePhone: String;
//   officeLocation: string;
//   preferredLanguage: string;
//   surname: string;
//   userPrincipalName: string;
// }
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isListVisible: boolean = false;
  isScreenSizeSmall: boolean = false;
  title = 'Lupin Supplier Portal';
  isIframe = false;
  loginDisplay = false;
  ext = false
  userName: any
  scsPort:boolean =false
  qualityPort:boolean =false
  vendorPort:boolean =false 
  profile: any
  GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
  private readonly _destroying$ = new Subject<void>();
  public scsAppDisplay=false;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private http: HttpClient,
    private openPoService: OpenPoService,
    private appConfigService: AppConfigService,
    private commonService: CommonService
  ) { 
    this.appConfigService.scsAppSubject.subscribe(res=>{
      this.scsAppDisplay = res;
    })
  }

  ngOnInit(): void {
    this.checkScreenSize();
    this.isIframe = window !== window.parent && !window.opener;

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }
  toggleListVisibility(){
    this.isListVisible= !this.isListVisible
  }
  checkScreenSize() {
    this.isScreenSizeSmall = window.innerWidth <= 700;
  }
  setLoginDisplay() {
   
   
    
    this.http.get(this.GRAPH_ENDPOINT)
    .pipe(
      tap( 
        (res:any)=>{
          let arrFil:any[]= [];
          arrFil=this.appConfigService.get('email');

         
          const mailValue = arrFil.filter(str => res['mail'].includes(str));
          mailValue.length == 1 ? localStorage.setItem("azureRole","Buyer") : localStorage.setItem("azureRole","Vendor");
        }
      ) 
    )
    .subscribe(profile => {
      this.profile = profile;
      this.userName = this.profile.userPrincipalName;
      localStorage.setItem("principal",this.profile.userPrincipalName);
      this.commonService.setEmail(this.profile.mail);
      
    });
    
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "https://fe.vp.demos.muraai.com/lupinAzure/",
        mainWindowRedirectUri: "https://fe.vp.demos.muraai.com/lupinAzure/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "https://fe.vp.demos.muraai.com/lupinAzure/",
      });
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
